import { useUtComparisonStore } from '../store/useUtComparisonStore';
import CompareTargetSection from './CompareTargetSection';

/**
 * ① 비교 대상 UT Matrix — 이 화면이 어떤 UT Matrix를 비교했는지 보여주기만 한다.
 *
 * [26.09.23] 행추가 / 행삭제 / 분석시작 / 초기화 버튼을 걷어냈다(더 이상 쓰지 않는 기능).
 * 그에 딸려 있던 것들도 같이 없앴다 — UT Matrix 선택 모달(행추가 전용)과
 * 행삭제 대상을 고르던 체크박스 열. 비교 대상은 저장된 리포트(rptId)나
 * location.state.matrices로 들어오므로 화면에서 편집할 경로가 없다.
 *
 * 섹션 자체는 전기 탭과 공용이다(CompareTargetSection) — 스토어만 여기서 붙여 준다.
 */
const UtMatrixSelector = () => {
  const selectedMatrices = useUtComparisonStore((s) => s.selectedMatrices);
  const historyRptId = useUtComparisonStore((s) => s.historyRptId);

  return (
    <CompareTargetSection
      matrices={selectedMatrices}
      historyRptId={historyRptId}
      emptyText="표시할 비교 대상 UT Matrix가 없습니다."
      emptyClassName="empty-state"
      bodyClassName="table-outer"
    />
  );
};

export default UtMatrixSelector;
